import { render, staticRenderFns } from "./Representative.vue?vue&type=template&id=35a4a47d&scoped=true"
import script from "./Representative.vue?vue&type=script&lang=js"
export * from "./Representative.vue?vue&type=script&lang=js"
import style0 from "./Representative.vue?vue&type=style&index=0&id=35a4a47d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4a47d",
  null
  
)

export default component.exports